import { breakpoints } from '@bnnvara/breakpoints';
import styled, { css } from 'styled-components';
export const StyledBaseCardBody = css`
  background: ${props => props.hasBodyBackground ? 'white' : 'transparent'};
  margin-bottom: -1px;
  z-index: 1;
  position: ${props => props.wide ? 'absolute' : 'relative'};
  bottom: 0;
  left: ${props => props.wide ? '8px' : '0'};
  right: 8px;

  ${breakpoints.md} {
    left: 0px;
    right: 0;
    position: relative;
    width: calc(100% - 20px);
  }

  span {
    font-family: ${({
  theme
}) => theme.fonts.primary};
    font-size: ${props => props.titleSizeSm ? props.titleSizeSm : '18px'};
    font-weight: bold;
    line-height: 1.27;
    word-break: break-word;
    color: ${props => props.wide ? ({
  theme
}) => theme.base.white : ({
  theme
}) => theme.base.black};
    margin: 0 0 4px;

    ${breakpoints.md} {
      font-size: ${props => props.titleSizeMd ? props.titleSizeMd : '20px'};
      color: ${({
  hasBodyBackground,
  theme
}) => hasBodyBackground ? theme.base.black : theme.base.white};
    }

    ${breakpoints.lg} {
      font-size: ${props => props.titleSizeLg ? props.titleSizeLg : '24px'};
    }

    &:after {
      content: '';
      transform: scaleX(0);
      height: 5px;
      border-bottom: 4px solid
        ${({
  backgroundColor,
  theme
}) => backgroundColor === 'red' ? theme.secondary.main : theme.primary.main};
      transition: all 0.2s ease-in-out;
      transform-origin: left center;
      display: block;
    }
  }
`;
export const CardImageContainer = styled.div`
  width: ${props => props.wide ? '100%' : '112px'};
  height: ${props => props.wide ? '176px' : '96px'};

  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  margin-right: 8px;
  background-color: ${({
  theme
}) => theme.secondary.dark};
  position: relative;

  ${breakpoints.md} {
    width: 100%;
    height: 100%;
    margin: 0;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
  }

  img {
    opacity: ${props => props.dark ? '0.7' : '1'};
  }
`;
export const CardImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  z-index: 0;
  flex-shrink: 0;
`;
export const BaseCardBodyContainer = styled.div`
  z-index: 5;
  width: 100%;

  ${breakpoints.md} {
    width: calc(100% - 40px);
  }
`;